// Generated by purs version 0.14.4
var otherwise = true;
export {
    otherwise
};
//# sourceMappingURL=index.js.map
